module.exports = __webpack_public_path__ + "img/2U.59c104bc.jpg";